import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = (
  route,
  state,
  platformId: object = inject(PLATFORM_ID),
  router: Router = inject(Router),
) => {
  if (isPlatformBrowser(platformId)) {
    const canAccess = !!localStorage.getItem(environment.accessTokenName);
    if (!canAccess) { router.navigate(['/login']); }
    return canAccess;
  } else {
    return true;
  }
};
